import { Link } from 'react-router';

import { buttonVariants } from '../components/ui/button.tsx';

function Message({ title, text }: { title: string; text: string }) {
  return (
    <div className="mx-auto max-w-md space-y-4 py-16 text-center">
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p className="text-muted-foreground">{text}</p>
      <Link to="/" className={buttonVariants({ variant: 'secondary' })}>
        Volver al inicio
      </Link>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <Message title="No encontramos esta página" text="Revisa la dirección o vuelve al inicio." />
  );
}

export function ForbiddenPage() {
  return (
    <Message
      title="No tienes acceso a esta sección"
      text="Si necesitas entrar, pide a un administrador de tu inmobiliaria que revise tu rol."
    />
  );
}
